import { createSelector } from 'reselect'

const select = (state) => state.recents

const selectRecentTopics = createSelector(select, (recents) => recents.topics)

export { selectRecentTopics }
